import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=4cd3615e&scoped=true"
import script from "./FileTable.vue?vue&type=script&lang=ts"
export * from "./FileTable.vue?vue&type=script&lang=ts"
import style0 from "./FileTable.vue?vue&type=style&index=0&id=4cd3615e&prod&lang=scss&scoped=true"
import style1 from "./FileTable.vue?vue&type=style&index=1&id=4cd3615e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd3615e",
  null
  
)

export default component.exports